import { Card, Divider, Grid, Stack, Typography } from '@mui/material'
import Document from '@/components/group/Document'
import { ObjectType } from '@/core/models/document.model'
import { useTranslation } from 'react-i18next'
import { getFileExtension, getFilename } from '@/utils/document'

export type BiologicalData = {
  label: string
  comment: string
  unit: string
  value: string
  file?: {
    filename: string
    key: string
    objectType: ObjectType
    url: string
    uploadedBy?: string
  }
  id: string
}

type BiologicalSectionProps = {
  data: BiologicalData[]
}

function BiologicalSection(props: BiologicalSectionProps) {
  const { data } = props
  const { t } = useTranslation()
  return (
    <Grid container spacing={2}>
      {data.map((biological, index) => (
        <Grid key={`${biological.label} - ${index}`} item xs={12} sm={6} md={4} lg={3}>
          <Card sx={{ width: '100%', minHeight: '150px', position: 'relative', p: '20px' }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" alignItems="center">
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing="10px" justifyContent="start" alignItems="center">
                <Typography fontWeight="800" fontSize="20px">
                  {biological.label}
                </Typography>
                <Divider sx={{ xs: 'horizontal', sm: 'vertical' }} />
                <Typography fontWeight="400">{biological.value}</Typography>
                <Typography fontWeight="400">{biological.unit}</Typography>
              </Stack>
            </Stack>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing="10px" alignItems="center" sx={{ mt: '30px' }}>
              <Typography fontWeight="400">{biological.comment ? biological.comment : t('component.group.biologicals.noComment')}</Typography>
            </Stack>
            {biological.file && (
              <Stack
                sx={{
                  maxHeight: '100px',
                  maxWidth: '100px',
                }}
              >
                <Document
                  disableAnnotation={true}
                  disableChangeName={true}
                  extension={getFileExtension(biological.file.filename)}
                  fileKey={biological.file.key}
                  name={getFilename(biological.file.filename)}
                  src={biological.file.url}
                />
              </Stack>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  )
}

export default BiologicalSection
